import React from 'react';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  dark?: boolean;
}
export function PageHeader({
  eyebrow,
  title,
  description,
  dark = false
}: PageHeaderProps) {
  return <div className={`py-16 lg:py-20 ${dark ? 'bg-navy' : 'bg-white'}`} data-id="element-47" data-mp="1me4d45wffq7l">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-48" data-mp="1r5nkk6sv9ue3">
        <p className={`text-xs font-semibold uppercase tracking-[0.14em] ${dark ? 'text-brandgreen-light' : 'text-brandgreen'}`} data-id="element-49" data-mp="1r76z9syvjxdr">
          {eyebrow}
        </p>
        <h1 className={`mt-3 max-w-3xl font-heading text-3xl font-semibold sm:text-4xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-50" data-mp="21669vh37a33e">
          {title}
        </h1>
        {description && <p className={`mt-4 max-w-2xl text-base leading-relaxed ${dark ? 'text-slate-300' : 'text-charcoal'}`} data-id="element-51" data-mp="bpew5zo0b5lc">
            {description}
          </p>}
      </div>
    </div>;
}